"use strict";

new Vue({
  mixins: [main],
  data: function data() {
    return {
      store: undefined,
      storeLoading: true,
      products: {},
      productsLoading: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    axios.get(apiUrl + '/api/get_store').then(function (response) {
      var success = function success(pos) {
        var r = Math.PI / 180;
        var lat = pos.coords.latitude;
        var lng = pos.coords.longitude;
        _this.store = response.data.items.filter(function (store) {
          return store.name !== 'らしんばんオンライン';
        }).reduce(function (prev, current) {
          var lat1 = lat * r;
          var lng1 = lng * r;
          var lat2 = current.latitude * r;
          var lng2 = current.longitude * r;
          current.distance = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
          return prev === undefined || prev.distance > current.distance ? current : prev;
        }, undefined);
        _this.storeLoading = false;
      };

      var fail = function fail() {
        response.data.items.some(function (store) {
          if (store.name === 'らしんばん秋葉原店新館') {
            _this.store = store;
            return true;
          }
        });
        _this.storeLoading = false;
      };

      navigator.geolocation.getCurrentPosition(success, fail);
    });
    axios.get('/products.json?timestamp=' + new Date().getTime()).then(function (response) {
      Object.keys(response.data).forEach(function (key) {
        _this.products[key] = response.data[key].map(function (item) {
          if (item.r18_flag && _this.getCookie('lashinbang_r18') !== '1') {
            item.img = templateDirectoryUri + '/img/online_r18.jpg';
          } else if (item.img === '') {
            item.img = templateDirectoryUri + '/img/online_noimage.jpg';
          } else {
            item.img = olineImgUrl + '/' + item.img;
          }

          item.url = olineUrl + item.url;
          item.r18Flag = false;
          return item;
        });
      });
      _this.productsLoading = false;

      _this.$nextTick(function () {
        initSlick('list');
      });
    })["catch"](function (error) {
      console.log(error);
    });
  }
});